export default {"src":"/_next/static/media/compliance.bb62718f.svg","height":56,"width":57,"blurWidth":0,"blurHeight":0};